import React from 'react';
import { Link } from 'react-router-dom';

const HorizonMark = ({ className = '' }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <rect x="1" y="1" width="38" height="38" rx="11" fill="url(#hzg)" />
    <circle cx="20" cy="17" r="5.5" fill="#fff" fillOpacity="0.95" />
    <path d="M7 27.5h26" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" />
    <path d="M11 32h18" stroke="#fff" strokeOpacity="0.6" strokeWidth="2.2" strokeLinecap="round" />
    <defs>
      <linearGradient id="hzg" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
        <stop stopColor="#0d9488" />
        <stop offset="1" stopColor="#0284c7" />
      </linearGradient>
    </defs>
  </svg>
);

const Logo = ({ variant = 'default', className = '' }) => {
  const textColor = variant === 'light' ? 'text-white' : 'text-dark-900';
  const subTextColor = variant === 'light' ? 'text-dark-300' : 'text-dark-400';

  return (
    <Link to="/" className={`flex items-center gap-3 group ${className}`}>
      <HorizonMark className="w-10 h-10 transition-transform group-hover:scale-105" />
      <div className="flex flex-col leading-tight">
        <span className={`font-display font-semibold text-xl tracking-tight ${textColor} transition-colors`}>
          Horizon <span className="text-athletic-600">Techline</span>
        </span>
        <span className={`text-[10px] font-medium uppercase tracking-[0.24em] ${subTextColor} transition-colors`}>
          Everyday Tech
        </span>
      </div>
    </Link>
  );
};

export default Logo;
